<script setup lang="ts">
import { computed } from "vue";
import PublicHeader from '@/components/navigation/PublicHeader.vue';
import Footer from '@/components/layout/Footer.vue';
import { useRoute } from "vue-router";
import routeManager from "@/router/route-manager";

const route = useRoute();
const showHeaderFooter = computed<boolean>( () => !( routeManager.isSignInPath( route.path ) ) );
const isHomePage = computed<boolean>( () => routeManager.isHomePath( route.path ) );
</script>

<template>
  <!--
    index.html carries viewport-fit=cover, so these insets are live. The header handles its own
    top inset (it is sticky, so the padding has to live on the header itself); the shell covers
    the sides in landscape and the home indicator at the bottom.
  -->
  <div class="public-shell flex min-h-dvh flex-col">
    <!-- Keyboard users had no way past the header nav on every route. -->
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:rounded focus:bg-base-100 focus:px-4 focus:py-2 focus:no-underline focus:shadow-lg"
    >Skip to main content</a>

    <PublicHeader v-if="showHeaderFooter" />

    <main id="main-content" tabindex="-1" :class="[ 'flex-1', isHomePage ? '' : 'm-4 gap-4' ]">
      <slot></slot>
    </main>

    <Footer v-if="showHeaderFooter" />
  </div>
</template>

<style scoped>
.public-shell {
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
</style>
